var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#E64A19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.345 2.121l7.186 12.77C20.72 17.003 19.555 19 17.133 19H2.877c-2.424 0-3.59-1.993-2.4-4.108l7.18-12.77c1.195-2.128 3.49-2.13 4.688 0zm-1.743.98c-.433-.768-.867-.619-1.202 0l-7.18 12.77c-.34.67-.237 1.129.657 1.129h14.256c.655 0 1.094-.348.655-1.128l-7.186-12.77zM10 16c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1zM9 7.003C9 6.449 9.444 6 10 6c.552 0 1 .449 1 1.003v4.994c0 .554-.444 1.003-1 1.003-.552 0-1-.449-1-1.003V7.003z",
    transform: "translate(-297 -315) translate(295 313) translate(2 2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.24d3048f600fbd0e2c724186caa43412.svg";
export { ForwardRef as ReactComponent };